import React from 'react'
import { motion } from 'framer-motion'
import { Container } from 'react-bootstrap'

import ResumeImage from '../../assets/Resume.png'

const containerVariants = {
    initial: {
        x: '-100vw',
        opacity: 0,
    },
    animate: {
        opacity: 1,
        x: 0,
        transition: {
            type: 'spring'
        }
    },
    exit: {
        x: '50vw',
        opacity: 0,
        transition: {
            duration: 0.5
        }
    }
}

const Resume = () => {
    return (
        <motion.section id='resume'
            variants={containerVariants}
            initial="initial"
            animate="animate"
            exit="exit"
        >
            <Container>
                <img
                    src={ResumeImage}
                    width='100%'
                    height='auto'
                />
            </Container>
        </motion.section>
    )
}

export default Resume;